import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceipt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M5.48438 11.5171V1.64526L6.58125 2.1937L7.67812 1.64526L8.77294 2.1937L9.8825 1.64526L10.9687 2.1937L12.0584 1.64526L13.1529 2.1937L14.2594 1.64526L15.3566 2.1937L16.4531 1.64526V9.32339",
			stroke: "currentColor",
			strokeWidth: 1.09687,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M16.4531 9.32349V13.1625C16.4531 13.8898 16.1642 14.5873 15.65 15.1016C15.1357 15.6158 14.4382 15.9047 13.7109 15.9047M13.7109 15.9047C12.9837 15.9047 12.2862 15.6158 11.7719 15.1016C11.2577 14.5873 10.9687 13.8898 10.9687 13.1625V11.5172H1.64531C1.57311 11.5166 1.50151 11.5303 1.43468 11.5577C1.36785 11.585 1.30714 11.6254 1.25608 11.6764C1.20503 11.7275 1.16465 11.7882 1.13732 11.855C1.10998 11.9219 1.09623 11.9935 1.09687 12.0657C1.09687 14.2594 1.3279 15.9047 3.83906 15.9047H13.7109Z",
			stroke: "currentColor",
			strokeWidth: 1.09687,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M7.67813 4.93604H14.2594M9.87188 7.67822H14.2594",
			stroke: "currentColor",
			strokeWidth: 1.09687,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgReceipt;
